import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm$dados, _vm$dados2, _vm$dados3, _vm$dados$regra, _vm$dados$regra2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "seller-commission-card shadow-sm h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "seller-commission-header"
  }, [_c('div', {
    staticClass: "seller-commission-title"
  }, [_c('span', {
    staticClass: "seller-title-icon"
  }, [_c('b-icon', {
    attrs: {
      "icon": "graph-up"
    }
  })], 1), _c('div', [_c('span', {
    staticClass: "seller-commission-eyebrow"
  }, [_vm._v("Meu desempenho")]), _c('h3', {
    staticClass: "mb-1"
  }, [_vm._v("Meta e comissão")]), _c('span', {
    staticClass: "seller-commission-period"
  }, [_vm._v(" " + _vm._s(((_vm$dados = _vm.dados) === null || _vm$dados === void 0 || (_vm$dados = _vm$dados.periodo) === null || _vm$dados === void 0 ? void 0 : _vm$dados.label) || "Mês atual") + " ")])])]), (_vm$dados2 = _vm.dados) !== null && _vm$dados2 !== void 0 && (_vm$dados2 = _vm$dados2.regra) !== null && _vm$dados2 !== void 0 && _vm$dados2.nome ? _c('span', {
    staticClass: "seller-rule-badge"
  }, [_vm._v(" " + _vm._s(_vm.dados.regra.nome) + " ")]) : _vm._e()]), _vm.loading ? _c('div', {
    staticClass: "seller-commission-loading"
  }, [_c('b-skeleton', {
    attrs: {
      "width": "38%",
      "height": "18px"
    }
  }), _c('b-skeleton', {
    staticClass: "mt-3",
    attrs: {
      "width": "58%",
      "height": "42px"
    }
  }), _c('b-skeleton', {
    staticClass: "mt-5",
    attrs: {
      "width": "100%",
      "height": "12px"
    }
  }), _c('div', {
    staticClass: "seller-loading-grid mt-5"
  }, _vm._l(3, function (item) {
    return _c('b-skeleton', {
      key: item,
      attrs: {
        "height": "92px"
      }
    });
  }), 1)], 1) : !_vm.dados || !_vm.dados.disponivel ? _c('div', {
    staticClass: "seller-commission-empty"
  }, [_c('div', {
    staticClass: "seller-empty-icon"
  }, [_c('b-icon', {
    attrs: {
      "icon": "person-badge"
    }
  })], 1), _c('strong', [_vm._v("Acompanhamento indisponível")]), _c('span', [_vm._v(" " + _vm._s(((_vm$dados3 = _vm.dados) === null || _vm$dados3 === void 0 ? void 0 : _vm$dados3.mensagem) || "Peça ao administrador para conferir seu vínculo de vendedor.") + " ")])]) : [_c('div', {
    staticClass: "seller-commission-hero"
  }, [_c('div', {
    staticClass: "seller-progress-copy"
  }, [_c('div', [_c('span', {
    staticClass: "seller-kicker"
  }, [_vm._v("Vendido no mês")]), _c('strong', {
    staticClass: "seller-sales-value"
  }, [_vm._v(" " + _vm._s(_vm.money(_vm.dados.realizado)) + " ")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "seller-kicker"
  }, [_vm._v("Meta")]), _c('strong', {
    staticClass: "seller-target-value"
  }, [_vm._v(_vm._s(_vm.money(_vm.dados.meta)))])])]), _c('div', {
    staticClass: "seller-progress-track"
  }, [_c('div', {
    staticClass: "seller-progress-fill",
    class: {
      completed: _vm.atingimento >= 100
    },
    style: {
      width: _vm.progressWidth
    }
  })]), _c('div', {
    staticClass: "seller-progress-footer"
  }, [_c('strong', [_vm._v(_vm._s(_vm.percent(_vm.atingimento)) + " da meta")]), _vm.dados.faltante_meta > 0 ? _c('span', [_vm._v(" Faltam " + _vm._s(_vm.money(_vm.dados.faltante_meta)) + " ")]) : _c('span', {
    staticClass: "seller-goal-complete"
  }, [_c('b-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "check-circle-fill"
    }
  }), _vm._v(" Meta alcançada ")], 1)])]), _c('div', {
    staticClass: "seller-summary-grid"
  }, [_c('div', {
    staticClass: "seller-summary-box commission"
  }, [_c('span', [_vm._v(_vm._s(_vm.dados.condicionado_recebimento ? "Comissão disponível" : "Comissão acumulada"))]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.dados.condicionado_recebimento ? _vm.dados.comissao_disponivel : _vm.dados.comissao_calculada)))]), _c('small', [_vm._v(_vm._s(_vm.currentCommissionLabel))])]), _c('div', {
    staticClass: "seller-summary-box range"
  }, [_c('span', [_vm._v("Faixa atual")]), _c('strong', [_vm._v(_vm._s(_vm.currentRangeLabel))]), _c('small', [_vm._v(_vm._s(_vm.currentRangeDetail))])]), _c('div', {
    staticClass: "seller-summary-box pace"
  }, [_c('span', [_vm._v("Ritmo para a meta")]), _c('strong', [_vm._v(_vm._s(_vm.paceLabel))]), _c('small', [_vm._v(_vm._s(_vm.paceDetail))])])]), _vm.dados.condicionado_recebimento ? _c('div', {
    staticClass: "seller-financial-note"
  }, [_c('div', [_c('b-icon', {
    attrs: {
      "icon": "wallet2"
    }
  }), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.money(_vm.dados.comissao_disponivel)))]), _vm._v(" já disponível ")])], 1), _c('div', [_c('b-icon', {
    attrs: {
      "icon": "clock-history"
    }
  }), _c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.money(_vm.dados.comissao_aguardando_recebimento)) + " ")]), _vm._v(" aguardando recebimentos ")])], 1)]) : _vm._e(), _vm.nextRange ? _c('div', {
    staticClass: "seller-next-range"
  }, [_c('div', {
    staticClass: "seller-next-icon"
  }, [_c('b-icon', {
    attrs: {
      "icon": "lightning-fill"
    }
  })], 1), _c('div', {
    staticClass: "seller-next-copy"
  }, [_c('span', [_vm._v("Próximo salto")]), _c('strong', [_vm._v(" " + _vm._s(_vm.percent(_vm.nextRange.percentual_meta)) + " da meta · " + _vm._s(_vm.rangeCommissionLabel(_vm.nextRange)) + " ")]), _c('small', [_vm._v(" Venda mais " + _vm._s(_vm.money(_vm.nextRange.falta_vender)) + " e sua comissão estimada passa para " + _vm._s(_vm.money(_vm.nextRange.comissao_projetada)) + ". ")])]), _c('div', {
    staticClass: "seller-next-gain"
  }, [_c('span', [_vm._v("Ganho potencial")]), _c('strong', [_vm._v("+ " + _vm._s(_vm.money(_vm.nextRange.ganho_adicional)))])])]) : _vm._e(), _vm.scenarios.length ? _c('div', {
    staticClass: "seller-range-section"
  }, [_c('div', {
    staticClass: "seller-range-heading"
  }, [_c('div', [_c('strong', [_vm._v("Mapa das faixas")]), _c('span', [_vm._v("Veja quanto cada conquista pode render.")])]), _c('span', {
    staticClass: "seller-projection-label"
  }, [_vm._v("Projeção no início da faixa")])]), _c('div', {
    staticClass: "seller-range-list"
  }, _vm._l(_vm.scenarios, function (range) {
    return _c('div', {
      key: "".concat(range.percentual_meta, "-").concat(range.percentual_comissao_vista, "-").concat(range.percentual_comissao_prazo),
      staticClass: "seller-range-item",
      class: _vm.rangeClass(range)
    }, [_c('div', {
      staticClass: "seller-range-status"
    }, [_c('b-icon', {
      attrs: {
        "icon": _vm.rangeIcon(range)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.rangeStatus(range)))])], 1), _c('strong', [_vm._v(_vm._s(_vm.percent(range.percentual_meta)) + " da meta")]), _c('span', [_vm._v(_vm._s(_vm.rangeCommissionLabel(range)))]), _c('small', [_vm._v(" " + _vm._s(_vm.money(range.comissao_projetada)) + " ")])]);
  }), 0)]) : _c('div', {
    staticClass: "seller-fixed-rule"
  }, [_c('b-icon', {
    attrs: {
      "icon": "percent"
    }
  }), _c('div', [_c('strong', [_vm._v("Comissão por modalidade")]), _c('span', [_vm._v(" À vista " + _vm._s(_vm.percent((_vm$dados$regra = _vm.dados.regra) === null || _vm$dados$regra === void 0 ? void 0 : _vm$dados$regra.percentual_vista)) + " · A prazo " + _vm._s(_vm.percent((_vm$dados$regra2 = _vm.dados.regra) === null || _vm$dados$regra2 === void 0 ? void 0 : _vm$dados$regra2.percentual_prazo)) + " ")])])], 1)]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };